import { GroupStudents } from "@/pages/groups/students"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/groepen/$groupId/students/")({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/students/",
  })

  return <GroupStudents groupId={Number(groupId)} />
}
